import GetReviewsModal from './GetReviewsModal'
export default GetReviewsModal;